/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconGhost = createReactComponent("outline", "ghost", "IconGhost", [["path", { "d": "M5 11a7 7 0 0 1 14 0v7a1.78 1.78 0 0 1 -3.1 1.4a1.65 1.65 0 0 0 -2.6 0a1.65 1.65 0 0 1 -2.6 0a1.65 1.65 0 0 0 -2.6 0a1.78 1.78 0 0 1 -3.1 -1.4v-7", "key": "svg-0" }], ["path", { "d": "M10 10l.01 0", "key": "svg-1" }], ["path", { "d": "M14 10l.01 0", "key": "svg-2" }], ["path", { "d": "M10 14a3.5 3.5 0 0 0 4 0", "key": "svg-3" }]]);

export { IconGhost as default };
//# sourceMappingURL=IconGhost.mjs.map
